import { Box, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../../bmr/components/features/Datatable"
// import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { EyeIconButton } from "../../../../assets/common-svg/CommonSvg";
// import { fetchMasterData } from "../../../slices/customMaster";
import { useLocation, useNavigate } from "react-router-dom";
import { masterKeys } from "../../../constants/constant";
import SubjectApi from "../../../../services/subjectService";

const DownloadCenter = () => {
    // const dispatch = useDispatch()
    const { pathname } = useLocation();
    const [subjectData, setSubjectData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const naviagte = useNavigate()
    const slug = pathname?.split('/')?.filter(Boolean)?.pop();
    const title = masterKeys?.[slug]
    const columns = [
        {
            id: 'patient_id',
            name: 'Patient ID',
            align: "center",
            selector: row => row.patient_id,
            sortable: true
        },
        {
            id: 'patient_name',
            name: 'Patient Name',
            align: "center",
            selector: row => row.first_name + ' ' + row.last_name,
            sortable: true
        },
        {
            id: 'product',
            name: 'Product',
            align: "center",
            selector: row => row.product_name,
            sortable: true
        },
        {
            id: 'phase',
            name: 'Phase',
            align: "center",
            selector: row => row.phase_name,
            sortable: true
        },
        {
            id: 'hospital',
            name: 'Hospital',
            align: "center",
            selector: row => row.hospitalDetails.name,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip
                    title={
                        row?.feasibility_assessments?.qr_code_generations?.[0]?.id &&
                            row?.feasibility_assessments?.id
                            ? "View"
                            : "QR code / Feasibility not available"
                    }
                >
                    <span>
                        <IconButton
                            disabled={
                                !row?.feasibility_assessments?.qr_code_generations?.[0]?.id ||
                                !row?.feasibility_assessments?.id
                            }
                            onClick={() => {
                                const qrId =
                                    row?.feasibility_assessments?.qr_code_generations?.[0]?.id;
                                const feasibilityId = row?.feasibility_assessments?.id;

                                if (!qrId || !feasibilityId) return;

                                naviagte(
                                    `/bmr/master/download-center/patient-details/${qrId}/${feasibilityId}`,
                                    { state: { row } }
                                );
                            }}
                        >
                            <EyeIconButton bgColor="#C3C3C3" />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>


        },
    ];

    const handleServerSideChange = async (params) => {
        try {
            setIsLoading(true)
            const res = await SubjectApi.getSubjectList(
                '',
                params.page,
                params.per_page,
                params.search,
                '',
                '',
                "",
                "",
                '',
                '',
                //@ above empty paramerte is for phase_id, editor id but in this case need all the patient.

            )
            setSubjectData({ items: res?.data, total_count: res.page_details.no_of_records, page: res?.page_details.page, per_page: res?.page_details.limit })
        } catch {

            setIsLoading(false)
        }
        finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        handleServerSideChange({ page: 1, per_page: 10, search: '' });
    }, []);

    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <Datatable
                columns={columns}
                data={subjectData}
                title={title}
                searchPlaceholder="Search by Patient Name"
                loading={isLoading}
                onServerSideChange={handleServerSideChange}
                remote={true}
            />
        </div>
    </div>
}
export default DownloadCenter